"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.assign");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _primitives = require("../primitives");

var defaultProps = {
  fontSize: 2,
  lineHeight: 1.25
};

var Body = function Body(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "div"
  }, p));
};

Body.defaultProps = Object.assign({}, defaultProps);

var P = function P(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "p"
  }, p));
};

P.defaultProps = Object.assign({}, defaultProps);

var Span = function Span(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "span"
  }, p));
};

Span.defaultProps = Object.assign({}, defaultProps);

var Ui = function Ui(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "span"
  }, p));
};

Ui.defaultProps = Object.assign({}, defaultProps);

var A = function A(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "a"
  }, p));
};

A.defaultProps = Object.assign({}, defaultProps);

var Strong = function Strong(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "strong"
  }, p));
};

Strong.defaultProps = Object.assign({}, defaultProps);

var Em = function Em(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "em"
  }, p));
};

Em.defaultProps = Object.assign({}, defaultProps);

var Ul = function Ul(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "ul"
  }, p));
};

Ul.defaultProps = Object.assign({}, defaultProps);

var Ol = function Ol(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "ol"
  }, p));
};

Ol.defaultProps = Object.assign({}, defaultProps);

var Li = function Li(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "li"
  }, p));
};

Li.defaultProps = Object.assign({}, defaultProps);

var Pre = function Pre(p) {
  return React.createElement(_primitives.Inline, (0, _extends2.default)({
    is: "pre"
  }, p));
};

Pre.defaultProps = Object.assign({}, defaultProps);

Body.p = function (props) {
  return React.createElement(P, props);
};

Body.span = function (props) {
  return React.createElement(Span, props);
};

Body.ui = function (props) {
  return React.createElement(Ui, (0, _extends2.default)({
    display: "inline-block"
  }, props));
};

Body.a = function (props) {
  return React.createElement(A, (0, _extends2.default)({
    display: "inline-block"
  }, props));
};

Body.strong = function (props) {
  return React.createElement(Strong, props);
};

Body.em = function (props) {
  return React.createElement(Em, props);
};

Body.ul = function (props) {
  return React.createElement(Ul, props);
};

Body.ol = function (props) {
  return React.createElement(Ol, props);
};

Body.li = function (props) {
  return React.createElement(Li, props);
};

Body.oli = function (props) {
  return React.createElement(Li, props);
};

Body.pre = function (props) {
  return React.createElement(Pre, props);
};

var _default = Body;
exports.default = _default;